import {
  ADD_KANBAN_ITEMS_TO_CART,
  ADD_KANBAN_ITEMS_TO_CART_FULFILLED,
  ADD_KANBAN_ITEMS_TO_CART_REJECTED,
  AddKanbanItemsToCartAction,
  AddKanbanItemsToCartFulfilledAction,
  AddKanbanItemsToCartRejectedAction,
  CLEAR_ADD_KANBAN_ITEMS_TO_CART,
  CLEAR_PLACE_KANBAN_ORDER,
  CLEAR_VERIFY_KANBAN_ITEMS,
  ClearAddKanbanItemsToCartAction,
  ClearPlaceKanbanOrderAction,
  ClearVerifyKanbanItemsAction,
  PLACE_KANBAN_ORDER,
  PLACE_KANBAN_ORDER_FULFILLED,
  PLACE_KANBAN_ORDER_REJECTED,
  PlaceKanbanOrderAction,
  PlaceKanbanOrderFulfilledAction,
  PlaceKanbanOrderRejectedAction,
  VERIFY_KANBAN_ITEMS,
  VERIFY_KANBAN_ITEMS_FULFILLED,
  VERIFY_KANBAN_ITEMS_REJECTED,
  VerifyKanbanItemsAction,
  VerifyKanbanItemsFulfilledAction,
  VerifyKanbanItemsRejectedAction,
} from 'b2b-apps/core/kanban';
import { AddItemsToCartType } from 'b2b-common/core/cart/api/CartTypes';
import {
  AddKanbanItemsToCartBodyType,
  PlaceKanbanOrderDataType,
  PlaceKanbanOrderRequestBodyType,
  VerifyKanbanItemsRequestBodyType,
  VerifyKanbanItemsType,
} from 'b2b-common/core/kanban/Kanban.types';

export const addKanbanItemsToCart = (data: AddKanbanItemsToCartBodyType): AddKanbanItemsToCartAction => ({
  type: ADD_KANBAN_ITEMS_TO_CART,
  payload: {
    data,
  },
});

export const addKanbanItemsToCartFulfilled = (response: AddItemsToCartType): AddKanbanItemsToCartFulfilledAction => ({
  type: ADD_KANBAN_ITEMS_TO_CART_FULFILLED,
  payload: {
    data: response,
  },
});

export const addKanbanItemsToCartRejected = (error: ErrorType): AddKanbanItemsToCartRejectedAction => ({
  type: ADD_KANBAN_ITEMS_TO_CART_REJECTED,
  payload: {
    error,
  },
});

export const clearAddKanbanItemsToCart = (): ClearAddKanbanItemsToCartAction => ({
  type: CLEAR_ADD_KANBAN_ITEMS_TO_CART,
});

export const verifyKanbanItems = (data: VerifyKanbanItemsRequestBodyType): VerifyKanbanItemsAction => ({
  type: VERIFY_KANBAN_ITEMS,
  payload: {
    data,
  },
});

export const verifyKanbanItemsFulfilled = (response: VerifyKanbanItemsType): VerifyKanbanItemsFulfilledAction => ({
  type: VERIFY_KANBAN_ITEMS_FULFILLED,
  payload: {
    data: response,
  },
});

export const verifyKanbanItemsRejected = (error: ErrorType): VerifyKanbanItemsRejectedAction => ({
  type: VERIFY_KANBAN_ITEMS_REJECTED,
  payload: {
    error,
  },
});

export const clearVerifyKanbanItems = (): ClearVerifyKanbanItemsAction => ({
  type: CLEAR_VERIFY_KANBAN_ITEMS,
});

export const placeKanbanOrder = (data: PlaceKanbanOrderRequestBodyType): PlaceKanbanOrderAction => ({
  type: PLACE_KANBAN_ORDER,
  payload: {
    data,
  },
});

export const placeKanbanOrderFulfilled = (data: PlaceKanbanOrderDataType): PlaceKanbanOrderFulfilledAction => ({
  type: PLACE_KANBAN_ORDER_FULFILLED,
  payload: {
    data,
  },
});

export const placeKanbanOrderRejected = (error: ErrorType): PlaceKanbanOrderRejectedAction => ({
  type: PLACE_KANBAN_ORDER_REJECTED,
  payload: {
    error,
  },
});

export const clearPlaceKanbanOrder = (): ClearPlaceKanbanOrderAction => ({
  type: CLEAR_PLACE_KANBAN_ORDER,
});
